module.exports = __webpack_public_path__ + "img/2.a45c01cf.webp";